interface BuoyageProps {
  onNavigate: (to: string) => void;
}

interface GameEntry {
  slug: string;
  name: string;
  blurb: string;
  ready: boolean;
}

const GAMES: readonly GameEntry[] = [
  {
    slug: "flashcards",
    name: "Identify the buoy",
    blurb:
      "See a buoy, pick its meaning. Cardinals, lateral marks, isolated danger, safe water, specials, emergency wrecks.",
    ready: true,
  },
];

export function Buoyage({ onNavigate }: BuoyageProps) {
  return (
    <>
      <p className="muted">
        The IALA Maritime Buoyage System. Cardinal, isolated-danger,
        safe-water, special and emergency-wreck marks are identical
        worldwide. <strong>Lateral marks invert between regions</strong>{" "}
        — Region A is red-to-port on entry, Region B is green-to-port.
        The full catalogue, with each mark's light and a Region A / B
        toggle, lives on the Reference tab; drill identification below.
      </p>

      <h2 style={{ marginTop: 24 }}>Games</h2>
      {GAMES.map((g) => (
        <div key={g.slug} className="card">
          <h3 style={{ marginBottom: 4 }}>{g.name}</h3>
          <p className="small muted" style={{ marginBottom: 12 }}>
            {g.blurb}
          </p>
          <button
            onClick={() => onNavigate(`/play/buoyage/${g.slug}`)}
            className="secondary"
          >
            Play
          </button>
        </div>
      ))}

      <button className="secondary" onClick={() => onNavigate("/play")}>
        ← Back to Play
      </button>
    </>
  );
}
